import React from 'react';
import { connect } from 'react-redux';

const Footer = ({ companyInfo }) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="copyright">
          &copy; {currentYear} Mettastay POS. All rights reserved.
        </div>
        {/* <div className="footer-links">
          <a href="#" className="footer-link">Terms of Service</a>
          <a href="#" className="footer-link">Privacy Policy</a>
          <a href="#" className="footer-link">Help</a>
        </div> */}
        <div className="version">
          Version 1.0.0
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  companyInfo: state.mainReducerData.companyInfo || {}
});

export default connect(mapStateToProps)(Footer);
